import GameObject, { GameObjectEvent } from '../../GameObject/GameObject';
import Element from '../UI/Element';
import Text from '../Text';
import { applyDefaultButtonAnimation } from '../../System/UI/UIHelper';
import Renderable from '../../Component/Renderable';
import { StartAnimationAsync } from '../../System/Animation/AnimationHelper';
import Interactable from '../../Component/Interactable';
import { MyPetMiniGameShareUi } from './MyPetMiniGameShareUi';
import Game from '../../Game';

interface IMyPetMiniGameHUDParams {
    picksLeft: number;
    displayRestoreContextMessage: boolean;
}

export class MyPetMiniGameHUD extends Element {
    private static BUTTON_CLAIM_NAME = 'button_claim';
    private static BUTTON_CLAIM_CONTAINER_NAME = 'claim_button_container';
    private static TITLE_TEXT_NAME = 'title_text';
    private static SHARE_CONTAINER_NAME = 'share_container';

    private picksLeftText: Text;
    private buttonClaim: GameObject;
    private buttonClaimContainer: GameObject;

    public create(params: IMyPetMiniGameHUDParams) {
        super.create(this.createHUD(params));

        this.picksLeftText = (this.findChildByName(
            MyPetMiniGameHUD.TITLE_TEXT_NAME
        ) as unknown) as Text;

        this.buttonClaim = this.findChildByName(
            MyPetMiniGameHUD.BUTTON_CLAIM_NAME
        );
        applyDefaultButtonAnimation(this.buttonClaim);

        this.buttonClaimContainer = this.findChildByName(
            MyPetMiniGameHUD.BUTTON_CLAIM_CONTAINER_NAME
        );
        this.buttonClaimContainer.getComponent(Renderable).visible = false;
        this.buttonClaim.addComponent(Interactable);
    }

    // Public part

    public addClaimClickListener(listener: () => void) {
        this.buttonClaim.on(GameObjectEvent.SELECTED, listener);
    }

    public async showClaimButton(): Promise<void> {
        this.buttonClaimContainer.getComponent(Renderable).visible = true;
        this.buttonClaimContainer.getComponent(Renderable).alpha = 0;
        this.buttonClaim.getComponent(Interactable).enabled = true;

        await StartAnimationAsync(this.buttonClaimContainer, 'Alpha', {
            startAlpha: 0,
            endAlpha: 1,
            duration: 300,
        });
    }

    public disableClaimButton(): void {
        this.buttonClaim.getComponent(Interactable).enabled = false;
    }

    // Private part

    private createHUD(params: IMyPetMiniGameHUDParams) {
        const hudLayer = {
            name: 'layer_hud',
            children: [
                {
                    name: 'layer_hud_top',
                    children: [this.createTitleBoard()],
                },
                {
                    name: MyPetMiniGameHUD.SHARE_CONTAINER_NAME,
                },
                this.createClaimButton(),
            ],
        };
        return hudLayer;
    }

    private createTitleBoard() {
        return {
            name: 'title',
            layout: {
                anchors: [0.5, 0, 0.5, 0],
                pivot: [0.5, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'pet_mini_board',
                    },
                },
            ],
            children: [
                {
                    name: MyPetMiniGameHUD.TITLE_TEXT_NAME,
                    layout: {
                        anchors: [0.5, 0, 0.5, 0],
                        offsets: [0, -55, 0, -55],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'MyPetMiniGameTitle',
                                style: {
                                    ...Game.style.getStyle('petMinigame'),
                                    fontSize: 38,
                                },
                                bounds: [800, 80],
                            },
                        },
                    ],
                },
                {
                    name: 'picks_left_title',
                    layout: {
                        anchors: [0.5, 0, 0.5, 0],
                        offsets: [0, -108, 0, -108],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'MyPetMiniGameSubTitle',
                                style: {
                                    ...Game.style.getStyle('petMinigame'),
                                    fontSize: 33,
                                    fill: '#fdff4a',
                                },
                                bounds: [600, 80],
                            },
                        },
                    ],
                },
            ],
        };
    }

    private createClaimButton() {
        return {
            name: MyPetMiniGameHUD.BUTTON_CLAIM_CONTAINER_NAME,
            layout: {
                anchors: [0.9, 1, 0.9, 1],
                offsets: [45, 110, 45, 110],
                scale: [0.92, 0.92],
            },
            children: [
                {
                    name: 'claim_button_background',
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'blank',
                            },
                        },
                    ],
                },
                {
                    name: MyPetMiniGameHUD.BUTTON_CLAIM_NAME,
                    components: [
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                                buttonMode: true,
                            },
                        },
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'pet_orange_button',
                            },
                        },
                    ],
                    children: [
                        {
                            name: 'claim_button_text',
                            layout: {
                                offsets: [0, 8, 0, 8],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'Continue',
                                        style: {
                                            ...Game.style.getStyle('petMinigame'),
                                            fontSize: 40,
                                            stroke: '#a11d19',
                                        },
                                        bounds: [250, 80],
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }
}
